import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseBlockquote from './HseBlockquote.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseBlockquote;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',{staticClass:"hse-Blockquote",class:( _obj = {}, _obj[("hse-Blockquote_variant_" + _vm.variant)] = _vm.variant, _obj['hse-Blockquote_hasMargin'] =  _vm.hasMargin, _obj )},[_c('div',{staticClass:"hse-Blockquote__left",class:_vm.classes.left},[(_vm.variant === _vm.BlockquoteVariant.normal)?_c('div',{staticClass:"hse-Blockquote__commas"}):_vm._e(),_vm._v(" "),(_vm.variant === _vm.BlockquoteVariant.rich)?_c('HsePerson',{staticClass:"hse-Blockquote__person",class:_vm.classes.avatar,attrs:{"classes":_vm.classes.personClasses,"src":_vm.avatarUrl,"alt":_vm.author}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"hse-Blockquote__right",class:_vm.classes.right},[(_vm.variant === _vm.BlockquoteVariant.rich)?_c('div',{staticClass:"hse-Blockquote__author",class:_vm.classes.author},[_vm._v("\n      "+_vm._s(_vm.author)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hse-Blockquote__content",class:_vm.classes.content},[_vm._t("default")],2),_vm._v(" "),(_vm.variant === _vm.BlockquoteVariant.normal)?_c('div',{staticClass:"hse-Blockquote__author",class:_vm.classes.author},[_vm._v("\n      "+_vm._s(_vm.author)+"\n    ")]):_vm._e()])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
